import send from './index';

export default {
    // 获取所有一级的游戏
    getAllGames(params: any = {}) {
        return send({
            url: '/game/getCasinoGamesV3/21',
            // url: '/game/getCasinoGames',
            method: 'get',
            params,
        });
    },
    // 获取游戏媒体
    getGameMate(data = {}) {
        return send({ data, url: '/game/getGameMate', method: 'post' });
    },
    // 搜索游戏
    searchGames(data: any = {}) {
        return send({ data, url: `/game/searchGames/${data.Page}/${data.Rows}`, method: 'post' });
    },
    // 打开游戏
    playGame(data = {}) {
        return send({ data, url: '/game/play', method: 'post' });
    },
    // 试玩游戏
    tryPlayGame(data = {}) {
        return send({ data, url: '/game/tryPlay', method: 'post' });
    },
    // 游戏平台
    findGameTypeList() {
        return send({ url: '/game/findGameTypeList', method: 'get' });
    },
    // 自营游戏
    findOfficialList() {
        return send({ url: '/official/game/findList', method: 'get' });
    },
    // 自营游戏注单
    findOfficialPage(data) {
        return send({ data, url: `/official/slot/findPage/${data.current}/${data.size}`, method: 'post' });
    },
    // 会员投注记录
    getBetRecordList(data: any = {}) {
        return send({ data, url: `/bet/bet${data.resType}/findPage/${data.page}/${data.rows}`, method: 'post' });
    },
    // 总计
    getBetRecordTotal(data: any = {}) {
        return send({ data, url: `/bet/betSlot/betSum/${data.type}`, method: 'post' });
    },

    // 自营彩票总计
    getBetOfficialRecordTotal(data: any = {}) {
        return send({ data, url: `/official/lottery/bet/sum`, method: 'post' });
    },

    // 自营彩票投注记录
    getBetOfficialRecordList(data: any = {}) {
        return send({ data, url: `/official/lottery/bet/findPage/${data.page}/${data.rows}`, method: 'post' });
    },

    // 自营体育总计
    getOfficialSportRecordTotal(data: any = {}) {
        return send({ data, url: `/official/sport/bet/sum`, method: 'post' });
    },

    // 自营体育投注记录
    getOfficialSportRecordList(data: any = {}) {
        return send({ data, url: `/official/sport/bet/findPage/${data.page}/${data.rows}`, method: 'post' });
    },

    // 获取轮盘数据
    findUserRouletteByType(data: any = {}) {
        return send({ data, url: `/roulette/findUserRouletteByType/${data.type}`, method: 'post' });
    },
};
